<script setup lang="ts">

import locale from 'element-plus/lib/locale/lang/zh-cn'
import { useUrlStore } from '@/store/UrlStore'

// 初始化url
useUrlStore().init();

</script>

<template>
  <el-config-provider :locale="locale">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <component :is="Component" v-if="!$route.meta.keepAlive"/>
   </router-view>
  </el-config-provider>
</template>

<style>
html, body {
  height: 100%;
}

html, body, div, input, button, p, form {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  height: 100%;
  font-family: PingFang SC, Microsoft YaHei
}

.el-message--error {
  background: #FEEDE9;
  border: 1px solid #FF4D4F;
  box-shadow: 0px 3px 7px 0px rgba(255, 77, 79, 0.25);
  border-radius: 4px;
  width: 33px;
}

.el-message {
  width: 330px;
  height: 36px;
}
</style>
